import { render, staticRenderFns } from "./sourseManager.vue?vue&type=template&id=54ea8adc"
import script from "./sourseManager.vue?vue&type=script&lang=js"
export * from "./sourseManager.vue?vue&type=script&lang=js"
import style0 from "./sourseManager.vue?vue&type=style&index=0&id=54ea8adc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports